import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DxDataGridModule } from 'devextreme-angular';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

import { PanelsModule } from '../../../shared/panels/panels.module';
import { DialogsModule } from '../../../shared/dialogs/dialogs.module';
import { DialogsService } from '../../../shared/dialogs/dialogs.service';
import { Select2Module } from '../../../shared/ui/forms/inputs/oops-select2/select2.module';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { DaterangepickerModule } from '../../../shared/ui/forms/inputs/oops-daterangepicker/daterangepicker.module';
import { UtilsModule } from '../../../shared/utils/utils.module';
import { Helper } from '../../../shared/helper/app.helper';

import { MediaComponent } from './media.component';
import { MediaTableComponent } from './media-table/media-table.component';
import { MediaDetailComponent } from './media-detail/media-detail.component';
import { MediaDetailDirective } from './media-detail/media-detail.directive';
import { MediaPreviewComponent } from './media-preview/media-preview.component';
import { MediaLibraryTableComponent } from './media-library-table/media-library-table.component';
import { MediaLibraryTableDirective } from './media-library-table/media-library-table.directive';
import { UiModule } from 'src/app/shared/ui/ui.module';
import { MatIconModule } from '@angular/material/icon';
import { FocusingModule } from 'src/app/shared/ui/forms/inputs/focusing.module';
import { OopsGemDatePickerModule } from 'src/app/shared/ui/forms/inputs/oops-gem-datepicker/oops-gem-datepicker.module';

@NgModule({
    declarations: [
        MediaComponent,
        MediaTableComponent,
        MediaDetailComponent,
        MediaDetailDirective,
        MediaPreviewComponent,
        MediaLibraryTableComponent,
        MediaLibraryTableDirective
    ],
    exports: [
        MediaComponent, MediaTableComponent, MediaDetailComponent, MediaDetailDirective,
        MediaPreviewComponent, MediaLibraryTableComponent, MediaLibraryTableDirective
    ],
    imports: [
        BsDropdownModule,
        ButtonsModule,
        CollapseModule,
        CommonModule,
        DaterangepickerModule,
        DialogsModule,
        DxDataGridModule,
        FocusingModule,
        FormsModule,
        MatIconModule,
        NgbModule,
        NgxDropzoneModule,
        OopsGemDatePickerModule,
        PanelsModule,
        ReactiveFormsModule,
        Select2Module,
        SweetAlert2Module,
        TooltipModule,
        UiModule,
        UtilsModule
    ],
    providers: [
        DialogsService, Helper
    ]
})
export class MediaModule {
}